import CardWrapper from '@components/UI/CardWrapper';
import Typography from '@mui/material/Typography';
import { DocumentFields } from '@services/requests/companyProfileService/types/documentsData';
import { DocumentFields as DealDocumentFields } from '@services/requests/dealPageService/types/documentsData';
import React from 'react';

import { DocumentItem } from './DocumentItem';
import { DocumentServiceType } from './helpers';
import { DocumentsModuleStyledContainer } from './StyledComponents';

interface DocumentsModuleProps {
  Icon: () => React.JSX.Element;
  title: string;
  documents: DocumentFields | DealDocumentFields;
  uploadText: string;
  editText: string;
  isAllowEdit: boolean;
  isArrayDocuments: boolean;
  serviceType: DocumentServiceType;
}

function DocumentsModule({
  Icon,
  title,
  documents,
  uploadText,
  editText,
  isAllowEdit,
  isArrayDocuments,
  serviceType,
}: DocumentsModuleProps) {
  const filteredDocuments = Object.values(documents).filter(
    (document) => document.editable || (!document.editable && !!document.value)
  );

  if (filteredDocuments.length === 0) {
    return null;
  }

  return (
    <DocumentsModuleStyledContainer>
      <CardWrapper sx={{ padding: '25px 90px 25px 40px' }} className="card">
        <Icon />
        <div className="documents-content">
          <Typography variant={'h3'} className={'module-title'}>
            {title}:
          </Typography>

          <div className="documents-list-wrapper">
            {Object.entries(documents).map(([code, document], index) => (
              <DocumentItem
                key={index}
                document={document}
                code={code}
                editText={editText}
                uploadText={uploadText}
                isAllowEdit={isAllowEdit}
                isArrayDocuments={isArrayDocuments}
                serviceType={serviceType}
              />
            ))}
          </div>
        </div>
      </CardWrapper>
    </DocumentsModuleStyledContainer>
  );
}
export { DocumentsModule };
